<dx-data-grid
*ngIf="entity"
[glamResource]="productBatchTechnicalFeatures!"
[addOptions]="['addTechnicalfeature', 'addTechnicalfeatureGroup']"
[createComponent]="technicalFeatureAdd"
[customParams]="{ productBatchId:entity.id }"
>

<dxo-editing class="hidden" [allowUpdating]="true"></dxo-editing>

<dxi-column name="code" [caption]="'common.code' | translate | ucfirst" dataField="technicalFeatureId" dataType="string" [allowEditing]="false">
  <dxo-lookup [dataSource]="technicalFeatures" displayExpr="code" valueExpr="id" />
</dxi-column>

<dxi-column name="name" [caption]="'common.name' | translate | ucfirst" dataField="technicalFeatureId" dataType="string"
  [allowEditing]="false">
  <dxo-lookup [dataSource]="technicalFeatures" displayExpr="name" valueExpr="id" />
</dxi-column>

<dxi-column name="valueTypeId" [caption]="'entity.technicalFeature.valueTypeId' | translate | ucfirst" dataField="technicalFeatureId" dataType="string" [allowEditing]="false">
  <dxo-lookup [dataSource]="technicalFeatures" displayExpr="valueTypeName" valueExpr="id" />
</dxi-column>

<dxi-column  width="200px" editCellTemplate="editTechnicalFeatureValue" [caption]="'common.value' | translate | ucfirst"
  dataField="value" dataType="string" />

<div *dxTemplate="let row of 'editTechnicalFeatureValue'" style="display: flex; overflow-x: auto;">

  <dx-number-box
    [(value)]="row.value"
    *ngIf="rowIsValueType(1, row)" (onValueChanged)="rowSetValue(1, row)"
    />
  <dx-text-box
    [(value)]="row.value"
    *ngIf="rowIsValueType(2, row)" (onValueChanged)="rowSetValue(2, row)"
    />
  <dx-text-box
    [(value)]="row.value"
    *ngIf="rowIsValueType(3, row)" (onValueChanged)="rowSetValue(3, row)"
    />
  <dx-select-box
    [(value)]="row.value"
    *ngIf="rowIsValueType(4, row)" (onValueChanged)="rowSetValue(4, row)"
    (onFocusIn)="getValuesFromTechnicalFeatures(row)"
    [items]="this.technicalFeaturesValues" displayExpr="display" valueExpr="value"
    />
  <dx-tag-box #tagBox
    [(value)]="onInitTagBoxValue"
    *ngIf="rowIsValueType(5, row)"
    (onFocusIn)="getValuesFromTechnicalFeaturesTagBox(row)"
    [items]="this.technicalFeaturesValues" valueExpr="value" displayExpr="display"
    [scrollable]="true" [multiline]="false" width="200"
    />

  </div>

</dx-data-grid>